import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getInitialLocale } from "../lib/localization";
import { isPublicAnalyticsPath, reportPageView } from "../lib/siteAnalytics";

export function PublicAnalyticsBeacon() {
  const location = useLocation();

  useEffect(() => {
    if (!isPublicAnalyticsPath(location.pathname)) return;
    reportPageView(location.pathname, getInitialLocale());
  }, [location.pathname]);

  return null;
}
